<script>
import moment from "moment";
// import ReplayCell from '@/components/gameList/ReplayCell.vue'
import ReplayCell from "@/components/visionTrainTrack/ReplayCell.vue";
import toPairs from "lodash/toPairs";
import sortBy from "lodash/sortBy";
function getRandomInt(min, max) {
  min = Math.ceil(min);
  max = Math.floor(max);
  return Math.floor(Math.random() * (max - min)) + min; //不含最大值，含最小值
}
export default {
  components: {
    ReplayCell
  },
  props: {
    type: {},
    patientTrainTrack: Array,
    patientId: String
  },
  data() {
    const ROLE_AGENT_OPTOMETRIST =
      localStorage.getItem("roles").indexOf("ROLE_AGENT_OPTOMETRIST") > -1 ||
      localStorage.getItem("roles").indexOf("ROLE_STATION_MANAGER") > -1;
    const start = moment()
      .subtract(6, "days")
      .format("YYYY-MM-DD");
    const end = moment().format("YYYY-MM-DD");
    const tempSearch = sessionStorage.getItem("searchFormData")
      ? JSON.parse(sessionStorage.getItem("searchFormData"))
      : {};
    const cache = sessionStorage.getItem("time");
    const value = cache
      ? cache.split(",")
      : tempSearch.dateRange
      ? tempSearch.dateRange
      : [start, end];

    return {
      list: [],
      editRow: "",
      value,
      dialogFormVisible: false,
      form: {
        customRemark: "",
        customTrainingRemark: ""
      },
      ROLE_AGENT_OPTOMETRIST,
      trainingRemarkDefault: [
        "项目退出方式异常",
        "未训练",
        "遗漏训练项目",
        "操作不灵活",
        "训练不认真",
        "训练暂停",
        "训练正常"
      ],
      handleRemarkDefault: [
        "再观察",
        "暂不回访",
        "调整关卡",
        "发送操作说明",
        "微信回访",
        "电话回访"
      ],
      trainingRemark: [],
      remark: [],
      tempSearch,
      resetNodeDialog: false,
      dialogKey: undefined
    };
  },
  computed: {
    title() {
      return `${moment().format("YYYY-MM-DD")}`;
    }
  },
  mounted() {
    // this.getGameReplay();
  },
  methods: {
    changeDate(type) {
      if (type === "next") {
        const newStart = moment(this.value[0])
          .add(1, "week")
          .startOf("week")
          .format("YYYY-MM-DD");
        const newEnd = moment(this.value[0])
          .add(1, "week")
          .endOf("week")
          .format("YYYY-MM-DD");
        this.value = [newStart, newEnd];
      } else if (type === "last") {
        const newStart = moment(this.value[0])
          .subtract(1, "week")
          .startOf("week")
          .format("YYYY-MM-DD");
        const newEnd = moment(this.value[0])
          .subtract(1, "week")
          .endOf("week")
          .format("YYYY-MM-DD");
        this.value = [newStart, newEnd];
      }
      sessionStorage.setItem("time", this.value);
      this.$emit("onChangeDate", this.value);
      // this.getGameReplay();
    },
    updateNode(date, item) {
      if (this.ROLE_AGENT_OPTOMETRIST) {
        this.editRow = date;
        this.dialogKey = getRandomInt(10, 1000);
        if (item) {
          this.form.customRemark = item.customRemark;
          this.form.customTrainingRemark = item.customTrainingRemark;
          this.trainingRemark = item.trainingRemark
            ? item.trainingRemark.split("#")
            : [];
          this.remark = item.remark ? item.remark.split("#") : [];
        }
        this.dialogFormVisible = true;
      }
    },
    async addAiNode(date, item) {
      if (this.ROLE_AGENT_OPTOMETRIST) {
        const row = this.patientTrainTrack.filter(
          o => o.trainingAt === date
        )[0];
        const params = {
          trackId: row.trackId,
          remark: ["再观察"].join("#"),
          trainingRemark: ["训练正常"].join("#")
        };
        let data = await this.$http.savePatientTrainingReamrk(params);
        this.$emit("onEditRemark");
      }
    },
    onClickTrainingTag(checked, index) {
      if (checked) {
        this.trainingRemark.push(this.trainingRemarkDefault[index]);
      } else {
        this.trainingRemark = this.trainingRemark.filter(
          o => o !== this.trainingRemarkDefault[index]
        );
      }
    },
    onClickHandleTag(checked, index) {
      if (checked) {
        this.remark.push(this.handleRemarkDefault[index]);
      } else {
        this.remark = this.remark.filter(
          o => o !== this.handleRemarkDefault[index]
        );
      }
    },
    async saveNote() {
      const temp = localStorage.getItem("activeHandlePatient");
      let activeHandlePatient = {
        patientId: this.patientId,
        time: moment().format("YYYY-MM-DD HH:mm:ss"),
        trainList: []
      };
      if (temp) {
        activeHandlePatient = JSON.parse(temp);
      }

      if (activeHandlePatient.patientId !== this.patientId) {
        activeHandlePatient.patientId = this.patientId;
        activeHandlePatient.trainList = [];
      }
      if (
        ((this.remark && this.remark.length > 0) ||
          (this.form.customRemark &&
            this.form.customRemark.replace(" ").length > 0)) &&
        ((this.trainingRemark && this.trainingRemark.length > 0) ||
          (this.form.customTrainingRemark &&
            this.form.customTrainingRemark.replace(" ").length > 0))
      ) {
        this.dialogFormVisible = false;
        const row = this.patientTrainTrack.filter(
          o => o.trainingAt === this.editRow
        )[0];
        let processDuration = undefined;
        const tempTime = moment().format("YYYY-MM-DD HH:mm:ss");
        processDuration = moment(tempTime).diff(
          activeHandlePatient.time,
          "seconds"
        );
        const tempworkTime = {
          trackId: row.trackId,
          end: tempTime
        };
        if (activeHandlePatient.trainList.length > 0) {
          tempworkTime.start =
            activeHandlePatient.trainList[
              activeHandlePatient.trainList.length - 1
            ].end;
        } else {
          tempworkTime.start = activeHandlePatient.time;
        }
        if (row.processDuration) {
          processDuration += row.processDuration;
        }
        activeHandlePatient.time = tempTime;
        activeHandlePatient.trainList.push(tempworkTime);
        localStorage.setItem(
          "activeHandlePatient",
          JSON.stringify(activeHandlePatient)
        );
        const params = {
          trackId: row.trackId,
          remark: this.remark.length ? this.remark.join("#") : "",
          trainingRemark: this.trainingRemark.length
            ? this.trainingRemark.join("#")
            : "",
          customRemark: this.form.customRemark,
          customTrainingRemark: this.form.customTrainingRemark,
          processDuration
        };
        let data = await this.$http.savePatientTrainingReamrk(params);
        this.$emit("onEditRemark");
      } else {
        this.$message.warning("请填写训练情况和处理方式！");
      }
    },
    onCloseRemarkDialog() {
      this.form = {
        customRemark: "",
        customTrainingRemark: ""
      };
      this.trainingRemark = [];
      this.remark = [];
      this.dialogFormVisible = false;
    },
    async resetNote() {
      const temp = localStorage.getItem("activeHandlePatient");
      let activeHandlePatient = {
        patientId: this.patientId,
        time: moment().format("YYYY-MM-DD HH:mm:ss"),
        trainList: []
      };
      if (temp) {
        activeHandlePatient = JSON.parse(temp);
      }
      const tempTime = moment().format("YYYY-MM-DD HH:mm:ss");
      if (activeHandlePatient.patientId !== this.patientId) {
        activeHandlePatient.patientId = this.patientId;
        activeHandlePatient.trainList = [];
      }
      activeHandlePatient.time = tempTime;

      this.dialogFormVisible = false;
      const row = this.patientTrainTrack.filter(
        o => o.trainingAt === this.editRow
      )[0];

      let data = await this.$http.resetPatientTrainingReamrk(row.trackId);
      this.resetNodeDialog = false;
      this.$emit("onEditRemark");
    },
    DeleteNode(row, item) {
      this.editRow = row;
      this.dialogKey = getRandomInt(10, 1000);
      this.resetNodeDialog = true;
    }
  }
};
</script>

<template>
  <div class="GameReplayView">
    <el-card class="box-card cardStyle" shadow="never">
      <div slot="header" class="clearfix">
        <span class="title">训练计划</span>
        <span style="float: right; padding: 3px 0" type="text">
          <el-button
            type="primary"
            @click="changeDate('last')"
            size="mini"
            style="margin-right: 12px;background-color: #00C1DE; border-color: #00C1DE"
          >
            <i class="el-icon-arrow-left" />前一周
          </el-button>
          <el-date-picker
            v-model="value"
            style="width: 240px"
            size="mini"
            @change="changeDate"
            type="daterange"
            range-separator="至"
            format="yyyy-MM-dd"
            start-placeholder="开始日期"
            value-format="yyyy-MM-dd"
            end-placeholder="结束日期"
          ></el-date-picker>
          <el-button
            size="mini"
            @click="changeDate('next')"
            type="primary"
            style="margin-left: 12px;background-color: #00C1DE; border-color: #00C1DE"
          >
            后一周
            <i class="el-icon-arrow-right" />
          </el-button>
        </span>
      </div>
      <div class="noneData" v-if="patientTrainTrack.length <= 0">
        <img class="iconStyle" src="../../assets/frown-o.png" />
        <span>暂无数据</span>
      </div>
      <div v-else>
        <div v-for="(item,index) in patientTrainTrack" :key="item.trackId + index">
          <div class="videoTitle">{{item.trainingAt}}</div>
          <div class="videoList">
            <div class="trainPlanList">
              <ReplayCell
                v-for="(obj,index) in item.gameTrack"
                :key="obj.trainingAt  + index"
                :item="obj"
                :trainingAt="item.trainingAt"
                :trainingResult="item.trainingResult"
              />
            </div>
            <div v-if="item.isAllWell && !item.note" class="trainNote">
              <div class="AIAddNote">
                <div class="advinceTitle">小沐智能建议</div>
                <div class="topView">
                  <img src="@/assets/xiaomuzhineng.png" class="xiaomuzhinengImg" />
                  <div class="AiAdvance">
                    <span class="advinceText">训练正常</span>
                    <br />
                    <span class="advinceText">再观察</span>
                    <br />
                  </div>
                </div>
                <div class="bottomView">
                  <el-button
                    type="text"
                    icon="el-icon-circle-plus"
                    @click="updateNode(item.trainingAt, item)"
                    size="medium"
                  >添加备注</el-button>
                  <el-button
                    type="primary"
                    @click="addAiNode(item.trainingAt, item)"
                    size="medium"
                  >应用建议</el-button>
                </div>
              </div>
            </div>
            <div
              v-else-if="!item.isAllWell && !item.note"
              class="trainNote"
              @click="updateNode(item.trainingAt, item)"
            >
              <div class="addNote">
                <i class="el-icon-circle-plus noteIcon" />
                <p>添加备注</p>
              </div>
            </div>
            <div v-else-if="item.note" class="trainNote">
              <div class="editNote">
                <div>
                  <p class="noteTitle">备注</p>
                  <i
                    v-if="ROLE_AGENT_OPTOMETRIST"
                    @click="DeleteNode(item.trainingAt, item)"
                    class="el-icon-delete noteIcon"
                  />
                  <i
                    v-if="ROLE_AGENT_OPTOMETRIST"
                    @click="updateNode(item.trainingAt, item)"
                    class="el-icon-edit noteIcon"
                  />
                </div>
                <div class="noteContent">{{item.note1}}</div>
                <div class="noteContent">{{item.note2}}</div>
              </div>
            </div>
            <div v-else class="trainNote">
              <div class="editNote">
                <div>
                  <p class="noteTitle">备注</p>
                  <i v-if="ROLE_AGENT_OPTOMETRIST" class="el-icon-edit noteIcon" />
                </div>
                <div class="noteContent">{{item.note}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <operationDialog
        title="添加备注"
        :center="true"
        width="520px"
        class="addNoteDialog"
        :Visible="dialogFormVisible"
        @close="onCloseRemarkDialog"
        btnText="确 定"
        @confirm="saveNote"
      >
        <el-form :model="form">
          <p class="tagLabel">训练情况</p>
          <!-- <CheckedItem text="aaaaa" :checked="true" /> -->
          <CheckedItem
            :key="tag+ editRow +dialogKey"
            v-for="(tag,index) in trainingRemarkDefault"
            :checked="trainingRemark.indexOf(tag) >= 0"
            :text="tag"
            @click="(checked) => onClickTrainingTag(checked,index)"
          />
          <el-form-item>
            <el-input
              type="textarea"
              v-model="form.customTrainingRemark"
              :rows="2"
              placeholder="请输入内容"
            ></el-input>
          </el-form-item>
          <p class="tagLabel">处理方式</p>
          <!-- <CheckedItem text="aaaaa" :checked="true" /> -->
          <CheckedItem
            :key="tag + editRow + dialogKey"
            v-for="(tag,index) in handleRemarkDefault"
            :checked="remark.indexOf(tag) >= 0"
            :text="tag"
            @click="(checked) => onClickHandleTag(checked,index)"
          />
          <el-form-item>
            <el-input type="textarea" v-model="form.customRemark" :rows="2" placeholder="请输入内容"></el-input>
          </el-form-item>
        </el-form>
      </operationDialog>
      <operationDialog
        title="请确认是否删除备注！"
        :center="true"
        width="300px"
        class="resetNoteDialog"
        :Visible="resetNodeDialog"
        @close="resetNodeDialog = false"
        btnText="确 定"
        @confirm="resetNote"
      />
      <router-view></router-view>
    </el-card>
  </div>
</template>

<style lang="scss">
.GameReplayView {
  .cardStyle {
    height: auto;
    border-bottom: 0px;

    .title {
      font-size: 18px;
      color: #171717;
    }
    .el-card__header {
      border-bottom: none;
    }
    .noneData {
      width: 100%;
      height: 150px;
      padding-top: 15%;
      text-align: center;
      font-size: 14px;
      color: rgba(0, 0, 0, 0.25);
      line-height: 24px;
    }

    .iconStyle {
      width: 20px;
      height: 20px;
      margin-bottom: -5px;
      padding-right: 10px;
    }

    .Button {
      float: left;
    }

    .GameReplay {
      position: relative;
      margin: 0 auto;
      overflow: auto;
      height: 100%;
      background: url("../../assets/doctor.png") no-repeat bottom right;
    }

    .videoList {
      display: flex;
      flex-wrap: wrap;
      align-items: flex-start;
      align-content: flex-start;
      .trainPlanList {
        display: flex;
        width: 800px;
      }
      .editPower {
        border: 0px solid #e4e8eb;
      }
      .trainNote {
        width: 200px;
        height: 260px;
        margin-top: 10px;
        margin-left: auto;
        margin-right: auto;
        text-align: center;
        border: 1px solid #e4e8eb;
        cursor: pointer;
        .addNote {
          margin: 45% 25% 0;
          .noteIcon {
            margin: -5px 5px 5px;
            font-size: 25px;
            // padding: 10px;
            color: #00c1de;
          }
        }
        .AIAddNote {
        }
        .editNote {
          background-color: #fffbe6;
          border-color: #ffe58f;
          height: inherit;
          overflow-y: hidden;
          .noteTitle {
            font-family: PingFangSC-Medium;
            font-size: 16px;
            color: rgba(0, 0, 0, 0.85);
            line-height: 24px;
            float: left;
            margin: 10px;
          }
          .noteIcon {
            // margin: 10px;
            font-size: 20px;
            line-height: 20px;
            float: right;
            padding: 10px;
            color: #00c1de;
          }
          .noteContent {
            display: flex;
            flex-wrap: wrap;
            justify-content: flex-start;
            text-align: left;
            width: 90%;
            padding-left: 10px;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: rgba(0, 0, 0, 0.65);
            line-height: 22px;
          }
        }
      }
    }

    .videoTitle {
      font-size: 14px;
      color: #171717;
      margin: 20px 10px 10px;
    }
    .tagLabel {
      margin-bottom: 10px;
    }
    .dialogTag {
      margin: 5px 10px;
      cursor: pointer;
      &:hover {
        background-color: #e3e3e3;
      }
    }

    .dialogButton {
      background-color: #00c1de;
      width: 300px;
      color: #fff;
      border-color: #00c1de;
    }
    .resetNoteDialog {
      .operationDialog .el-dialog__body {
        padding: 0 0 10px;
      }
    }
    .addNoteDialog {
      .operationDialog {
        margin-bottom: 0px !important;
        .el-dialog__footer .el-button--primary {
          width: 300px;
        }
      }
    }
  }
}
</style>
<style lang="scss" scoped>
.GameReplayView {
  .trainNote {
    width: 200px;
    height: 260px;
    margin-top: 10px;
    margin-left: auto;
    margin-right: auto;
    // text-align: center;
    border: 1px solid #e4e8eb;
    cursor: pointer;
    .advinceTitle {
      font-size: 16px;
      font-weight: bold;
      line-height: 24px;
      margin: 20px 10px 10px 15px;
      text-align: left;
    }
    .AIAddNote {
      .topView {
        display: flex;
        margin: 10px 0px 10 10px;
        text-align: left;
        .xiaomuzhinengImg {
          width: 80px;
          height: 100px;
          margin: 10px;
        }
        .AiAdvance {
          margin-top: 30px;
        }
        .advinceText {
          font-size: 14px;
          line-height: 20px;
        }
        border-bottom: 1px solid #e4e8eb;
      }

      .bottomView {
        display: flex;
        margin: 20px 10px;
        justify-content: space-between;
      }
    }
  }
}
</style>


// WEBPACK FOOTER //
// src/components/visionTrainTrack/GameReplay.vue